export function isLightBox(wixCodeApi) {
  var _wixCodeApi$site$curr;
  return ((_wixCodeApi$site$curr = wixCodeApi.site.currentPage) == null ? void 0 : _wixCodeApi$site$curr.type) === 'lightbox';
}
//# sourceMappingURL=isLightBox.js.map